import { BaseIp, ProIp } from "./ApiURL";


//Post mapping
export const userLoginAPI = ProIp + "userLoginAPI"